import { z } from "zod";
export const listBookingsQuerySchema = z.object({
    search: z.string().trim().min(1).optional(),
});
